"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceClaimNoteType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsuranceClaimNoteType_Factory = /** @class */ (function () {
    function InsuranceClaimNoteType_Factory() {
    }
    InsuranceClaimNoteType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    InsuranceClaimNoteType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return InsuranceClaimNoteType_Factory;
}());
exports.InsuranceClaimNoteType_Factory = InsuranceClaimNoteType_Factory;
